import { QRCodeProductRestaurantsLine } from 'Components/lines/qrcode-product-restaurants-line/QRCodeProductRestaurantsLine';
export default QRCodeProductRestaurantsLine;
